import React from "react";

import "./index.scss";

interface SideIconProps {
  width?: number;
  height?: number;
  classes?: string;
  style?: any;
}

const WorkspaceHomeIcon: React.FC<SideIconProps> = ({
  classes,
  width = 12,
  height = 12,
  style,
}) => {
  return (
    <svg
      width={width || "12"}
      height={height || "12"}
      className={classes}
      style={style}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#F8F9FA" />
      <path
        d="M2.4375 4.42188L5.71875 1.96094C5.88542 1.83594 6.11458 1.83594 6.28125 1.96094L9.5625 4.42188C9.68053 4.5104 9.75 4.64933 9.75 4.79688V8.78125C9.75 9.04013 9.54013 9.25 9.28125 9.25H7.875C7.61612 9.25 7.40625 9.04013 7.40625 8.78125V6.4375C7.40625 6.17862 7.19638 5.96875 6.9375 5.96875H5.0625C4.80362 5.96875 4.59375 6.17862 4.59375 6.4375V8.78125C4.59375 9.04013 4.38388 9.25 4.125 9.25H2.71875C2.45987 9.25 2.25 9.04013 2.25 8.78125V4.79688C2.25 4.64933 2.31947 4.5104 2.4375 4.42188Z"
        fill="#25c16f"
      />
    </svg>
  );
};

export default WorkspaceHomeIcon;
